var formElementStyle = {
    default: {
        appearance: 'none',
        boxSizing: 'border-box',
        display: 'block',
        margin: 0,
        padding: '0 0 1rem 0',
        width: '100%',
        verticalAlign: 'top'
    },
    textDirection: {
        rtl: {
            alignItems: 'right',
            textAlign: 'right',
            direction: 'rtl'
        },
        ltr: {
            alignItems: 'left',
            textAlign: 'left',
            direction: 'ltr'
        }
    }
};
export default formElementStyle;
